import { render, staticRenderFns } from "./article.vue?vue&type=template&id=24a70e50&"
import script from "./article.js?vue&type=script&lang=js&"
export * from "./article.js?vue&type=script&lang=js&"
import style0 from "./article.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports